// ============================================================
// fondos/decoracion.js — ¿ESTE HIJO DE LA SECCIÓN ES DECORACIÓN? (módulo PURO)
//
// Varias coreografías recorren los hijos DIRECTOS de una <section> para esconderlos o
// animarlos: el sticky de la timeline v4 (los esconde y monta su panel), la entrada genérica del
// orquestador (los funde de uno en uno) y el replay de entrada del editor. Cada una llevaba SU
// lista de lo que no es contenido, y ninguna coincidía: la timeline escondía también el fondo
// animado (se veía en el editor y nunca en el publicado, L5 del plan del motor de fondos) y la
// entrada genérica filtraba una clase que no existe (`background-layer`) en vez de `bg-layer`.
// Ahora las tres preguntan aquí.
//
// Decoración = las capas que cuelgan de la sección sin ser contenido: el fondo animado, la forma
// decorativa, el separador (parche SVG) y su hueco de recorte, el resplandor ambiental, y las
// etiquetas que no se pintan (<style>, <script>). Los FANTASMAS (`.ghost-text`/`.ghost-number`)
// NO entran a propósito: son texto de la sección, y la timeline v4 tiene que esconderlos con el
// resto del contenido que sustituye su panel.
//
// MÓDULO PURO: ES2019, sin DOM propio (solo lee `tagName` y `classList` del elemento que recibe),
// testeable en node con objetos de imitación.
// ============================================================

export const CLASES_DECORACION = [
    'bg-layer', 'canvas-shape-decor', 'section-divider', 'n3i-recorte-hueco', 'ambient-glow-layer',
];

const _ETIQUETAS_SIN_PINTAR = ['STYLE', 'SCRIPT'];

/** ¿`el` es decoración de su sección (y no contenido)? */
export function esDecoracion(el) {
    if (!el) return false;
    const tag = typeof el.tagName === 'string' ? el.tagName.toUpperCase() : '';
    if (_ETIQUETAS_SIN_PINTAR.indexOf(tag) !== -1) return true;
    const cl = el.classList;
    if (!cl || typeof cl.contains !== 'function') return false;
    for (let i = 0; i < CLASES_DECORACION.length; i++) {
        if (cl.contains(CLASES_DECORACION[i])) return true;
    }
    return false;
}
